export default "__VITE_ASSET__f3ae9d03__"